import { IDataGridOptions, IColDef } from 'components/common/DataGridDevEx/DataGrid.properties';

import {
  createActions, asyncInitialState, asyncOnRequest,
  asyncOnSuccess, asyncOnError, asyncSelectors,
  IDataAction,
  IExtendedState
} from '../utils';

export interface ISerialsData {
  selected: any;
  gridOptions: IDataGridOptions;
  deleteObj: any;
  Actions: any;
  lineColumns: IColDef[];
  lines: any[];
}

export interface ISerialsState extends IExtendedState<ISerialsData> {
}

export const { types, actions } = createActions(
  {
    setSelected: (row) => ({ row }),
    clearLines: () => null,
    asyncs: {
      fetch: (Data) => (Data),
    }
  },
  'PSSerials');

const initialState = asyncInitialState<ISerialsData>({
  selected: null,
  gridOptions: {
    doubleClickActionTab: '',
    suppressEditDeleteInContextMenu: true,
    rowModelType: 'serverSide',
    cacheBlockSize: 10,
    maxBlocksInCache: 5,
  },
  deleteObj: null,
  Actions: {
  },
  lineColumns: [
    { headerName: 'Serial number', field: 'SerialNumber', minWidth: 150, suppressSorting: true }
  ],
  lines: []
});

export default (state: ISerialsState = initialState, action: IDataAction): ISerialsState => {
  switch (action.type) {
    case types.setSelected:
      const selected = action.data.row;

      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      };
    case types.fetch:
      return asyncOnRequest(state, action);
    case types.saga.fetch.success:
      return asyncOnSuccess(state, action, (data, successAction) => {
        const linesData = successAction.payload && successAction.payload.records;

        return {
          ...data,
          lines: linesData
        };
      });

    case types.saga.fetch.failure:
      return asyncOnError(state, action);
    default:
      return state;
  }
};

const asyncSelector = asyncSelectors(
  (state: { pickSlips: { serials: ISerialsState } }) => state.pickSlips.serials,
  {
    lines: (data) => data.lines,
    selected: (data) => data.selected,
  }
);

const syncSelector = {
  isLoading: (state: { pickSlips: { serials: ISerialsState } }) => state.pickSlips.serials.loading,
  gridOptions: (state: { pickSlips: { serials: ISerialsState } }) => state.pickSlips.serials.data.gridOptions,
  lineColumns: (state: { pickSlips: { serials: ISerialsState } }) => state.pickSlips.serials.data.lineColumns
};

export const selectors = { ...asyncSelector, ...syncSelector };
